import React from 'react';

import illustrationMoverWithSixteenFootTruck from '@images/illustrations/mover_with_sixteen_foot_truck.svg';
import illustrationOnlinePhotoCatalog from '@images/illustrations/online_photo_catalog_large.svg';
import illustrationOnlineQuote from '@images/illustrations/online_quote.svg';

import { InfoCardItem } from './info_card_item';
import { InfoCardList } from './info_card_list';

export const MovingWithClutter = () => (
  <InfoCardList title="Moving with Clutter Is As Easy As 1-2-3">
    <InfoCardItem
      label="1"
      title="Book your move completely online."
      icon={illustrationOnlineQuote}
    />
    <InfoCardItem
      label="2"
      title="Sort, organize and get ready for your move."
      icon={illustrationOnlinePhotoCatalog}
    />
    <InfoCardItem
      label="3"
      title="We take care of your move, including disposal and storage."
      icon={illustrationMoverWithSixteenFootTruck}
    />
  </InfoCardList>
);
